import { makeStyles } from 'tss-react/mui';
import { STEPPER_GREY } from 'utilities/colors';

export const useStyles = makeStyles()({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '80vh',
    position: 'relative',
  },
  content: { flexGrow: 1, overflowY: 'auto' },
  stepper: {
    position: 'fixed',
    color: STEPPER_GREY,
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'transparent',
    '& .MuiMobileStepper-dotActive': {
      backgroundColor: STEPPER_GREY,
    },
    '& .MuiSvgIcon-root': {
      color: STEPPER_GREY,
    },
  },
});
